export default function(password) {
    let res = {};
    res.status = true;
    res.message = 'Password must contain:'
    if (!password.match(/[a-z]/g)) {
        res.message += '<br /><span>- A <strong>lower case</strong> letter</span>';
        res.status = false;
    }
    if (!password.match(/[A-Z]/g)) {
        res.message += '<br /><span>- A <strong>capital (uppercase)</strong> letter</span>';
        res.status = false;
    }
    if (!password.match(/[0-9]/g)) {
        res.message += '<br /><span>- At least one <strong>number</strong></span>';
        res.status = false;
    }
    if (password.length < 8) {
        res.message += '<br /><span>- Minimum <strong>8 characters</strong></span>';
        res.status = false;
    }
    return res;
};
